var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "cooperation 1",
    clipPath: "url(#clip0_46_365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5223"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g5225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5227",
    d: "M54.1829 64.3005L45.9984 59.4517",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g5229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5231",
    d: "M49.0901 67.9752L43.0597 64.4026",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g5233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5235",
    d: "M42.9181 71.0105L40.5549 69.6106",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_46_365",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 78
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath5243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5241",
    d: "M0 7.62939e-06H78V78H0V7.62939e-06Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_46_365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5247",
    d: "M38.8738 44.2087L38.458 43.9628C36.0671 42.5907 34.9489 42.337 32.792 43.1709L30.4409 44.0797C29.0103 44.6328 27.405 44.4992 26.0854 43.7174L24.6316 42.8603",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5251",
    d: "M15.6249 57.9075L18.061 59.3453",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5255",
    d: "M36.0832 73.6531L39.9836 75.9639C41.3514 76.7742 43.1172 76.3223 43.9275 74.9545C44.738 73.5866 44.286 71.8209 42.9181 71.0104L46.1555 72.9284C47.5234 73.7388 49.2893 73.2871 50.0996 71.919C50.9099 70.5513 50.4579 68.7854 49.0901 67.9751L51.2484 69.2538C52.6161 70.0641 54.382 69.6124 55.1924 68.2445V68.2443C56.0027 66.8766 55.5507 65.1109 54.183 64.3004L56.8242 65.8653C58.1921 66.6755 59.9576 66.2236 60.7679 64.856C61.5782 63.4883 61.1264 61.7226 59.7585 60.9123",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5259",
    d: "M53.7133 43.5205L53.3741 43.7175C52.0545 44.4993 50.4493 44.6328 49.0188 44.0798L46.3674 43.0382C45.5382 42.7123 44.6276 42.6547 43.7638 42.8733L39.7018 43.9014C37.8107 44.38 36.4861 46.0817 36.4861 48.0322V53.4548C36.4861 54.2216 37.1073 54.8451 37.8741 54.8457C40.1861 54.8473 42.061 52.9734 42.061 50.6616V50.432L59.4486 60.7289C59.7708 60.3857 60.14 60.0891 60.5463 59.8484L62.7952 58.5344",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5263",
    d: "M20.8144 65.3138C19.8875 66.6049 18.0894 66.9001 16.7983 65.9731C15.5072 65.0463 15.2119 63.2482 16.1389 61.9572L17.769 59.6865C18.6959 58.3954 20.494 58.1 21.7851 59.0269C23.0762 59.9539 23.3715 61.752 22.4446 63.0431",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5267",
    d: "M28.9191 63.8938L25.4898 68.6704C24.563 69.9615 22.765 70.2567 21.4738 69.3299C20.1826 68.403 19.8874 66.6049 20.8144 65.3138L24.2437 60.5372C25.1705 59.2459 26.9685 58.9508 28.2596 59.8777C29.5507 60.8046 29.846 62.6025 28.9191 63.8938Z",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5271",
    d: "M28.9191 63.8938C29.8459 62.6025 31.6441 62.3074 32.9352 63.2343C34.2263 64.1611 34.5215 65.9592 33.5945 67.2504L30.1654 72.0269C29.2386 73.3181 27.4404 73.6133 26.1493 72.6864C24.8582 71.7596 24.563 69.9615 25.4898 68.6704",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5275",
    d: "M32.0709 69.3728C32.9977 68.0817 34.7958 67.7864 36.0869 68.7133C37.3781 69.6403 37.6733 71.4383 36.7463 72.7294L35.6061 74.3179C34.6791 75.609 32.881 75.9041 31.5901 74.9772C30.2989 74.0504 30.0037 72.2522 30.9306 70.9613",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5279",
    d: "M33.351 7.21771V4.26468C33.351 2.81163 34.5284 1.63371 35.9815 1.63371H42.0187C43.4718 1.63371 44.6491 2.81163 44.6491 4.26468V7.21771",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5283",
    d: "M30.5044 15.0521V19.851",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5287",
    d: "M47.4957 15.0521V19.851",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5291",
    d: "M73.0551 55.561L75.2152 54.2734C76.2336 53.6663 76.8575 52.568 76.8575 51.3825V28.5047C76.8575 27.4992 75.762 26.8769 74.8982 27.3917L54.4034 39.608C53.2514 40.2947 52.8722 41.7845 53.5559 42.9387L62.9275 58.7573C63.6136 59.9159 65.1103 60.2967 66.2669 59.6074L68.4303 58.3178",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5295",
    d: "M3.10187 27.3917L23.5965 39.608C24.7489 40.2947 25.128 41.7847 24.4442 42.9387L15.0727 58.7574C14.3864 59.9159 12.8898 60.2967 11.7332 59.6074L2.78484 54.2733C1.76643 53.6664 1.14258 52.5682 1.14258 51.3826V28.5049C1.14258 27.4992 2.23823 26.8769 3.10187 27.3917Z",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5299",
    d: "M22.7441 18.9617V10.3764C22.7441 8.63174 24.1583 7.21769 25.9026 7.21769H52.0974C53.8417 7.21769 55.2561 8.63174 55.2561 10.3764V25.9613C55.2561 27.7058 53.8417 29.12 52.0974 29.12H25.9026C24.1583 29.12 22.7441 27.7058 22.7441 25.9613V24.3033",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5303",
    d: "M22.7441 11.7281C22.7441 14.8891 25.3065 17.4515 28.4675 17.4515H49.5324C52.6933 17.4515 55.2561 14.8891 55.2561 11.7281",
    stroke: "#013A57",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNature);
export default __webpack_public_path__ + "static/media/nature.e181bc50b871752870de1e5a8c3cae67.svg";
export { ForwardRef as ReactComponent };